module.exports = __webpack_public_path__ + "img/waerme-img3v2.1af3fe5a.png";